import { imageAsset } from '@/data/sanity/fragments'
import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  title,
  ${imageAsset.fragment('image')},
  items[] {
    largeNumber,
    text,
  }
`

export const fragment = (name = 'stats') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
